//this pattern validates that the name doesn't start with a number or simbol, only alpha and underscore
const columnPattern = /^[A-Za-z_]([A-Za-z0-9_])*$/i; // eslint-disable-line

const validSnowflakeTable = value => {
    const pattern = /[^a-zA-Z0-9_]+/i; // eslint-disable-line
    return !pattern.test(value);
};

export const validSnowflakeTableSpaces = value => {
    const pattern = /[^a-zA-Z0-9_ ]+/; // eslint-disable-line
    return !pattern.test(value);
};

export const validStartChar = value => !columnPattern.test(value);

export default validSnowflakeTable;

export const validSnowflakeColumn = value => columnPattern.test(value);
export const parseValidColumnName = value => value.replace(!columnPattern, "_");
